import { StatusTerritoryAccess } from '@/config/types';

export const getTerritoryAccess = (territoryAccess: any) => {
  switch (territoryAccess) {
    // PENDING
    case StatusTerritoryAccess.pending:
      return {
        message: 'As informações do produtor estão bloqueadas para visualização.',
        pending: true,
        denied: false,
        granted: false,
      };
    // DENIED
    case StatusTerritoryAccess.denied:
      return {
        message: 'As informações do produtor estão disponíveis para visualização.',
        pending: false,
        denied: true,
        granted: false,
      };
    // GRANTED
    case StatusTerritoryAccess.granted:
      return {
        message: 'As informações do produtor estão disponíveis para visualização.',
        pending: false,
        denied: false,
        granted: true,
      };
    // NONE
    default:
      return {
        message:
          'As informações do produtor estão bloqueadas para visualização. Para conseguir visualizá-las, solicite o acesso.',
        pending: false,
        denied: false,
        granted: false,
      };
  }
};

export default getTerritoryAccess;
